import type { FunctionComponent } from 'react'
import React from 'react'
import { Hero } from '@which/seatbelt'

import classnames from 'classnames'

import styles from './SubVerticalHeader.module.scss'

export const SubVerticalHeader: FunctionComponent<Props> = ({
  image,
  intro,
  title,
  variant,
  links,
}) => (
  <div
    className={classnames(styles.subVerticalHeader, {
      [styles.subVerticalHeaderReviews]: variant === 'reviews',
      [styles.subVerticalHeaderHubs]: variant === 'hubs',
    })}
    data-testid="sub-vertical-header"
  >
    <Hero title={title} standfirst={intro} image={image} size={1} lazyLoad={false} links={links} />
  </div>
)

type Props = Parameters<typeof Hero>[0] & {
  intro: string
  variant?: string
}
